import request from "../utils/request";

export function getDlps(uuid, params) {
  return request({
    url: `/dlps/list/${uuid}`,
    method: "get",
    data: params,
  });
}
